module.exports = __webpack_public_path__ + "72473e20822a310ac5ae9ea1c77f6127.eot";


//////////////////
// WEBPACK FOOTER
// ./css/fonts/ComicNeue/ComicNeue-Bold.eot
// module id = 386
// module chunks = 0